import * as yup from 'yup';

import type { ComplianceDocumentStatus } from '../../../types/api';
import { commonSchemas } from '../../../components/forms/validation';
import { COMPLIANCE_TYPE_OPTIONS, EVENT_BASED_TYPES } from './spec';

export const complianceStatusOptions: ComplianceDocumentStatus[] = [
  'draft',
  'active',
  'expired',
  'archived',
];

const buildExpirySchema = (required: boolean) => {
  const baseSchema = required
    ? commonSchemas.date.required('La fecha de vencimiento es requerida')
    : commonSchemas.optionalDate;
  return baseSchema.test(
    'expiry-after-issue',
    'La fecha de vencimiento debe ser posterior a la fecha de emisión',
    function (value) {
      const { issue_date } = this.parent as { issue_date?: string };
      if (!value || !issue_date) return true;
      return new Date(value) >= new Date(issue_date);
    },
  );
};

const buildComplianceSchema = (requireExpiryDate: boolean) =>
  yup.object({
    type: yup
      .string()
      .oneOf(
        COMPLIANCE_TYPE_OPTIONS.map((option) => option.value),
        'Tipo de documento inválido',
      )
      .required('Tipo de documento es requerido'),
    issuing_authority: yup
      .string()
      .trim()
      .required('Autoridad emisora es requerida'),
    jurisdiction: yup.string().trim().required('Jurisdicción es requerida'),
    issue_date: commonSchemas.date,
    expiry_date: buildExpirySchema(requireExpiryDate),
    next_due_date: commonSchemas.optionalDate.when('type', {
      is: (value: string) => EVENT_BASED_TYPES.has(value),
      then: (schema) =>
        schema.required('La próxima fecha de vencimiento es requerida'),
      otherwise: (schema) => schema.optional(),
    }),
    status: yup
      .mixed<ComplianceDocumentStatus>()
      .oneOf(complianceStatusOptions, 'Estado inválido')
      .required('Estado es requerido'),
    notes: commonSchemas.notes
      .optional()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .default(undefined),
    tags: yup
      .string()
      .optional()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .default(undefined),
  });

export const complianceSchema = buildComplianceSchema(false);
export const complianceRenewSchema = buildComplianceSchema(true);

export type ComplianceFormValues = yup.InferType<typeof complianceSchema>;
